module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "el-loading-mask",
    class: [_vm.customClass, {
      'is-fullscreen': _vm.fullscreen
    }]
  }, [_c('div', {
    staticClass: "el-loading-spinner"
  }, [_c('svg', {
    staticClass: "circular",
    attrs: {
      "viewBox": "25 25 50 50"
    }
  }, [_c('circle', {
    staticClass: "path",
    attrs: {
      "cx": "50",
      "cy": "50",
      "r": "20",
      "fill": "none"
    }
  })]), _vm._v(" "), (_vm.text) ? _c('p', {
    staticClass: "el-loading-text"
  }, [_vm._v(_vm._s(_vm.text))]) : _vm._e()])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-27f632d7!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/loading/src/loading.vue
// module id = 626
// module chunks = 0